import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { RatesApiAdapter } from '../adapters/RatesApiAdapter';
import { CreateRateRequest, Rate } from '../models/rate.types';

export const useCreateRate = () => {
  const queryClient = useQueryClient();

  const adapter = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    return new RatesApiAdapter(httpClient);
  }, []);

  return useMutation<Rate, Error, CreateRateRequest>({
    mutationFn: (data: CreateRateRequest) => adapter.createRate(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['rates'] });
    },
  });
};
